import React from 'react';

import { SelectValueType } from '.';
import { ButtonIcon } from '../Button';
import { cn } from '../cn';
import { buttonHPadding, buttonMinHeight, buttonText } from '../common';
import { ButtonPropsSizeType } from '../common.type';
import { Tooltip } from '../Tooltip';

type SelectDropdownProps<T> = {
  selectOption: (value: T) => void;
  optionRow?: (value: T, size?: ButtonPropsSizeType) => React.ReactNode;
  setHighlightedOptionValue: (v: string) => void;
  highlightedOptionValue: string | undefined;
  data: T;
  size?: ButtonPropsSizeType;
};

export default function SelectDropdownRow<T extends SelectValueType>({
  size,
  data,
  highlightedOptionValue,
  setHighlightedOptionValue,
  optionRow,
  selectOption,
}: SelectDropdownProps<T>) {
  return (
    <div
      className={cn(
        'flex shrink-0 cursor-pointer transition-colors',
        'text-slate-600 dark:text-slate-200',
        'active:bg-slate-300',
        'hover:bg-slate-400 hover:text-slate-200 active:bg-slate-500',
        'border-b border-slate-200 last:border-none dark:border-charade-700',
        { 'bg-slate-500 text-slate-200': highlightedOptionValue === data.value },
        buttonText(size),
        buttonMinHeight(size),
      )}
      data-option-value={`option-${data.value}`}
      key={data.value}
      onMouseDown={() => selectOption(data)}
      onMouseMove={() => setHighlightedOptionValue(data.value)}>
      {optionRow != null && optionRow(data, size)}
      {optionRow == null && (
        <div className="flex grow items-center truncate">
          {data.icon && (
            <Tooltip label={data.iconTooltip}>
              <ButtonIcon size={size}>{data.icon}</ButtonIcon>
            </Tooltip>
          )}
          <span
            className={cn(
              'flex flex-1 items-baseline justify-between self-center whitespace-nowrap',
              buttonHPadding(size),
            )}>
            {data.labelJsx}
            {data.labelJsx == null && <span>{data.label}</span>}
            <span className={cn('text-xs opacity-40')}>{data.desc}</span>
          </span>
        </div>
      )}
    </div>
  );
}
